function EmailIcon() {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.9395 3C18.2805 3 19.5705 3.53 20.5195 4.481C21.4695 5.43 22.0005 6.71 22.0005 8.05V15.95C22.0005 18.74 19.7305 21 16.9395 21H7.06049C4.26949 21 2.00049 18.74 2.00049 15.95V8.05C2.00049 5.26 4.25949 3 7.06049 3H16.9395ZM18.0705 8.2C17.8605 8.189 17.6605 8.26 17.5095 8.4L13.0005 12C12.4205 12.481 11.5895 12.481 11.0005 12L6.50049 8.4C6.18949 8.17 5.75949 8.2 5.50049 8.47C5.23049 8.74 5.20049 9.17 5.42949 9.47L5.56049 9.6L10.1105 13.15C10.6705 13.59 11.3495 13.83 12.0605 13.83C12.7695 13.83 13.4605 13.59 14.0195 13.15L18.5305 9.54L18.6105 9.46C18.8495 9.17 18.8495 8.75 18.5995 8.46C18.4605 8.311 18.2695 8.22 18.0705 8.2Z"
          fill="black"
        />
      </svg>
    </>
  );
}
function PhoneIcon() {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.5317 12.4724C15.5208 16.4604 16.4258 11.8467 18.9656 14.3848C21.4143 16.8328 22.8216 17.3232 19.7192 20.4247C19.3306 20.737 16.8616 24.4943 8.1846 15.8197C-0.493478 7.144 3.26158 4.67244 3.57397 4.28395C6.68387 1.17385 7.16586 2.58938 9.61449 5.03733C12.1544 7.5765 7.54266 8.48441 11.5317 12.4724Z"
          fill="black"
        />
      </svg>
    </>
  );
}

function YoytubeIcon() {
  return (
    <>
      <svg
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_4435_12021)">
          <path
            d="M20.7907 6.30018C20.7907 6.30018 20.5856 4.85233 19.954 4.2166C19.1542 3.37988 18.2601 3.37578 17.8499 3.32656C14.9132 3.11328 10.504 3.11328 10.504 3.11328H10.4958C10.4958 3.11328 6.08668 3.11328 3.14998 3.32656C2.73983 3.37578 1.84569 3.37988 1.04589 4.2166C0.414255 4.85233 0.21328 6.30018 0.21328 6.30018C0.21328 6.30018 0 8.00232 0 9.70035V11.2917C0 12.9898 0.209178 14.6919 0.209178 14.6919C0.209178 14.6919 0.414255 16.1398 1.04179 16.7755C1.84159 17.6122 2.89159 17.5835 3.35916 17.6737C5.04079 17.8337 10.4999 17.8829 10.4999 17.8829C10.4999 17.8829 14.9132 17.8747 17.8499 17.6655C18.2601 17.6163 19.1542 17.6122 19.954 16.7755C20.5856 16.1398 20.7907 14.6919 20.7907 14.6919C20.7907 14.6919 20.9999 12.9939 20.9999 11.2917V9.70035C20.9999 8.00232 20.7907 6.30018 20.7907 6.30018ZM8.33023 13.2236V7.32146L14.0027 10.2828L8.33023 13.2236Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_4435_12021">
            <rect width="20.9999" height="20.9999" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
}
function InstaIcon() {
  return (
    <>
      <svg
        width="19"
        height="19"
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_4435_12022)">
          <path
            d="M9.83366 1.98421C12.2829 1.98421 12.5729 1.99495 13.5361 2.03792C14.4313 2.07731 14.9147 2.2277 15.237 2.35303C15.6631 2.51774 15.971 2.71826 16.2897 3.03695C16.612 3.35921 16.8089 3.66357 16.9736 4.08968C17.099 4.41195 17.2493 4.89893 17.2887 5.79053C17.3317 6.75732 17.3424 7.04736 17.3424 9.493C17.3424 11.9422 17.3317 12.2323 17.2887 13.1955C17.2493 14.0907 17.099 14.5741 16.9736 14.8963C16.8089 15.3224 16.6084 15.6304 16.2897 15.9491C15.9674 16.2713 15.6631 16.4683 15.237 16.633C14.9147 16.7583 14.4277 16.9087 13.5361 16.9481C12.5693 16.991 12.2793 17.0018 9.83366 17.0018C7.38444 17.0018 7.0944 16.991 6.13119 16.9481C5.236 16.9087 4.7526 16.7583 4.43034 16.633C4.00423 16.4683 3.69629 16.2677 3.3776 15.9491C3.05534 15.6268 2.8584 15.3224 2.69369 14.8963C2.56836 14.5741 2.41797 14.0871 2.37858 13.1955C2.33561 12.2287 2.32487 11.9386 2.32487 9.493C2.32487 7.04378 2.33561 6.75374 2.37858 5.79053C2.41797 4.89534 2.56836 4.41195 2.69369 4.08968C2.8584 3.66357 3.05892 3.35563 3.3776 3.03695C3.69987 2.71468 4.00423 2.51774 4.43034 2.35303C4.7526 2.2277 5.23958 2.07731 6.13119 2.03792C7.0944 1.99495 7.38444 1.98421 9.83366 1.98421ZM9.83366 0.333496C7.34505 0.333496 7.03353 0.344238 6.05599 0.387207C5.08203 0.430176 4.41244 0.587728 3.83236 0.813314C3.22721 1.04964 2.71517 1.36117 2.20671 1.87321C1.69466 2.38167 1.38314 2.89372 1.14681 3.49528C0.921224 4.07894 0.763672 4.74495 0.720703 5.71891C0.677734 6.70003 0.666992 7.01156 0.666992 9.50016C0.666992 11.9888 0.677734 12.3003 0.720703 13.2778C0.763672 14.2518 0.921224 14.9214 1.14681 15.5015C1.38314 16.1066 1.69466 16.6187 2.20671 17.1271C2.71517 17.6356 3.22721 17.9507 3.82878 18.1834C4.41244 18.409 5.07845 18.5666 6.05241 18.6095C7.02995 18.6525 7.34147 18.6632 9.83008 18.6632C12.3187 18.6632 12.6302 18.6525 13.6077 18.6095C14.5817 18.5666 15.2513 18.409 15.8314 18.1834C16.4329 17.9507 16.945 17.6356 17.4535 17.1271C17.9619 16.6187 18.277 16.1066 18.5098 15.505C18.7354 14.9214 18.8929 14.2554 18.9359 13.2814C18.9788 12.3039 18.9896 11.9924 18.9896 9.50374C18.9896 7.01514 18.9788 6.70361 18.9359 5.72607C18.8929 4.75212 18.7354 4.08252 18.5098 3.50244C18.2842 2.89372 17.9727 2.38167 17.4606 1.87321C16.9522 1.36475 16.4401 1.04964 15.8385 0.816895C15.2549 0.591309 14.5889 0.433757 13.6149 0.390788C12.6338 0.344238 12.3223 0.333496 9.83366 0.333496Z"
            fill="white"
          />
          <path
            d="M9.83366 4.7915C7.23405 4.7915 5.125 6.90055 5.125 9.50016C5.125 12.0998 7.23405 14.2088 9.83366 14.2088C12.4333 14.2088 14.5423 12.0998 14.5423 9.50016C14.5423 6.90055 12.4333 4.7915 9.83366 4.7915ZM9.83366 12.5545C8.14714 12.5545 6.7793 11.1867 6.7793 9.50016C6.7793 7.81364 8.14714 6.4458 9.83366 6.4458C11.5202 6.4458 12.888 7.81364 12.888 9.50016C12.888 11.1867 11.5202 12.5545 9.83366 12.5545Z"
            fill="white"
          />
          <path
            d="M15.828 4.60514C15.828 5.21387 15.3338 5.70443 14.7287 5.70443C14.12 5.70443 13.6294 5.21029 13.6294 4.60514C13.6294 3.99642 14.1235 3.50586 14.7287 3.50586C15.3338 3.50586 15.828 4 15.828 4.60514Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_4435_12022">
            <rect
              width="18.3333"
              height="18.3333"
              fill="white"
              transform="translate(0.666992 0.333496)"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
}

function TweeterIcon() {
  return (
    <>
      <svg
        width="19"
        height="19"
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.3325 1.7876H16.9095L11.2796 8.22221L17.9027 16.9783H12.7169L8.65511 11.6678L4.00754 16.9783H1.42903L7.45076 10.0957L1.09717 1.7876H6.41468L10.0862 6.6416L14.3325 1.7876ZM13.4281 15.4358H14.856L5.63879 3.24902H4.10648L13.4281 15.4358Z"
          fill="white"
        />
      </svg>
    </>
  );
}

function FacebookIcon() {
  return (
    <>
      <svg
        width="19"
        height="19"
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_4435_12024)">
          <path
            d="M9.16667 0.333496C4.1041 0.333496 0 4.4376 0 9.50016C0 13.799 2.95973 17.4062 6.95237 18.397V12.3015H5.0622V9.50016H6.95237V8.2931C6.95237 5.17313 8.3644 3.727 11.4275 3.727C12.0083 3.727 13.0104 3.84103 13.4204 3.9547V6.49386C13.204 6.47113 12.8282 6.45976 12.3614 6.45976C10.8585 6.45976 10.2777 7.0292 10.2777 8.50943V9.50016H13.2719L12.7574 12.3015H10.2777V18.5997C14.8166 18.0516 18.3337 14.1869 18.3337 9.50016C18.3333 4.4376 14.2292 0.333496 9.16667 0.333496Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_4435_12024">
            <rect
              width="18.3333"
              height="18.3333"
              fill="white"
              transform="translate(0 0.333496)"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
}
function CardIcon() {
  return (
    <>
      <svg
        width="68"
        height="73"
        viewBox="0 0 68 73"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.0285 23.1859C14.112 22.924 15.2195 22.7922 16.3304 22.7929C25.1279 22.7929 32.2576 30.9409 32.2576 40.9879C32.2576 51.0379 25.1279 59.1859 16.3304 59.1859C7.53289 59.1859 0.400391 51.0409 0.400391 40.9879C0.400391 40.6939 0.406016 40.3969 0.420078 40.1029H0.400391C0.400391 24.9379 11.2004 12.5989 24.4754 12.5989V18.7069C20.1695 18.7069 16.1982 20.3809 13.0285 23.1859ZM48.6741 23.1859C49.7373 22.9279 50.8398 22.7929 51.9704 22.7929C60.7679 22.7929 67.9004 30.9409 67.9004 40.9879C67.9004 51.0379 60.7679 59.1859 51.9704 59.1859C43.1729 59.1859 36.0432 51.0409 36.0432 40.9879C36.0432 40.6939 36.0488 40.3969 36.0629 40.1029H36.0432C36.0432 24.9379 46.8432 12.5989 60.1182 12.5989V18.7069C55.8095 18.7069 51.8438 20.3809 48.6741 23.1859Z"
          fill="#003386"
        />
      </svg>
    </>
  );
}
function BackIcon() {
  return (
    <>
      <svg
        width="57"
        height="58"
        viewBox="0 0 57 58"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle opacity="0.4" cx="28.5" cy="28.6998" r="28.5" fill="#D9D9D9" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.0553 40L21.4011 30.0065C21.1442 29.739 21 29.3772 21 29C21 28.6228 21.1442 28.261 21.4011 27.9935L31.0553 18L33 20.013L24.3249 28.9929L33 37.9727L31.0553 40Z"
          fill="#2F3438"
        />
      </svg>
    </>
  );
}

function ForwardIcon() {
  return (
    <>
      <svg
        width="58"
        height="58"
        viewBox="0 0 58 58"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          opacity="0.4"
          cx="29.4092"
          cy="28.6998"
          r="28.5"
          transform="rotate(180 29.4092 28.6998)"
          fill="#D9D9D9"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.1067 17L37.5655 27.4478C37.8438 27.7274 38 28.1057 38 28.5C38 28.8943 37.8438 29.2726 37.5655 29.5522L27.1067 40L25 37.8955L34.398 28.5075L25 19.1194L27.1067 17Z"
          fill="#2F3438"
        />
      </svg>
    </>
  );
}
export {
  EmailIcon,
  PhoneIcon,
  InstaIcon,
  YoytubeIcon,
  FacebookIcon,
  TweeterIcon,
  CardIcon,
  BackIcon,
  ForwardIcon,
};
